import React from 'react';
import { Button } from 'react-native-paper';

type StepFormNavigationProps = {
  disabledBack?: boolean;
  disabledForward?: boolean;
  isSubmitting?: boolean;
  styles: Record<string, {}>;
  onNextButtonClick: () => void;
  onPrevButtonClick: () => void;
};

const StepFormNavigation: React.FC<StepFormNavigationProps> = ({
  disabledBack,
  disabledForward,
  styles,
  isSubmitting = false,
  onNextButtonClick,
  onPrevButtonClick,
}) => {
  const events = {
    onNextButtonClick: () => {
      onNextButtonClick();
    },
    onPrevButtonClick: () => {
      onPrevButtonClick();
    },
  };

  return (
    <>
      <Button
        style={[styles.commonButtonWrapper, styles.prevButtonWrapper]}
        contentStyle={styles.commonButtonContent}
        labelStyle={[styles.commonButtonLabel, styles.prevButtonLabel]}
        onPress={events.onPrevButtonClick}
        disabled={disabledBack || isSubmitting}
      >
        戻る
      </Button>
      <Button
        style={[styles.commonButtonWrapper, styles.nextButtonWrapper]}
        contentStyle={styles.commonButtonContent}
        labelStyle={[styles.commonButtonLabel, styles.nextButtonLabel]}
        onPress={events.onNextButtonClick}
        disabled={disabledForward || isSubmitting}
      >
        次へ
      </Button>
    </>
  );
};

export default StepFormNavigation;
